import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const OperationsReports = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      { name: "Mother Plant Details", reportUrl: "/MotherPlant", icon: "fa-seedling" },
      { name: "Nursary Transfer", reportUrl: "/nurseryTransfer", icon: "fa-exchange-alt" },
      { name: "Nursery Observation Reports", reportUrl: "/NurseryObservationReport", icon: "fa-chart-bar"},
      { name: "Nursery Sowing Input Report", reportUrl: "/NurserySowingInputReport", icon: "fa-file-alt" },
      { name: "Nursery Sowing Output Report", reportUrl: "/NurserySowingOutputReport", icon: "fa-file-alt" },
      { name: "Labour Details", reportUrl: "/LabourDetails", icon: "fa-exchange-alt" },
     
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = [
    "#4caf50", "#ff9800", "#e91e63", "#9c27b0", "#2196f3",
    "#795548", "#03a9f4", "#8bc34a", "#f44336", "#607d8b",
    "#673ab7", "#009688", "#ff5722", "#3f51b5", "#00bcd4",
    "#c2185b"
  ];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">📋 Nursery Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">{item.name}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};



export default OperationsReports;